import { DRAWING_EXCLUDED_GROUPS } from "./access.mjs";

export default {
    title: "Files",
    icon: "mdi-file-cad-box",
    excludeGroups: [...DRAWING_EXCLUDED_GROUPS],
    submenu: [
        {
            title: "Disegni",
            route: { name: "disegni" },
            excludeGroups: [...DRAWING_EXCLUDED_GROUPS],
        },
        {
            title: "DXFCUT",
            route: { name: "dxfcut" },
            excludeGroups: [...DRAWING_EXCLUDED_GROUPS],
        },
        {
            title: "Documenti Dipendenti",
            route: { name: "documentale-browser" },
            excludeGroups: [...DRAWING_EXCLUDED_GROUPS],
        },
    ],
};
